import React from 'react';
import LegalPage from './LegalPage';

export default function Terms() {
  return <LegalPage pageKey="terms" />;
}
